import { useEffect } from "react";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import ServicesOverview from "@/components/ServicesOverview";
import WhyChooseUs from "@/components/WhyChooseUs";
import CTASection from "@/components/CTASection";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";

const Index = () => {
  // Handle anchor links from footer - scroll to top first
  useEffect(() => {
    // Always scroll to top when page loads
    window.scrollTo({ top: 0, behavior: 'smooth' });
    
    const hash = window.location.hash.replace('#', '');
    if (hash) {
      // Optional: Scroll to the section if it exists (commented out for now)
      // setTimeout(() => {
      //   const element = document.getElementById(hash);
      //   if (element) {
      //     element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      //   }
      // }, 100);
    }
  }, []);

  return (
    <>
      <SEO
        title="ADGS - Digitalisera er framtid"
        description="Personlig expertis inom mjukvara och digitalisering. Vi hjälper företag att effektivisera verksamheten och bygga skräddarsydda digitala lösningar."
        canonicalUrl="https://adgs.se/"
        ogImage="https://adgs.se/hero-background.jpg"
      />
      <div className="min-h-screen bg-background">
        <div className="relative">
          <Header />
          <main>
            <Hero />
            <ServicesOverview />
            <WhyChooseUs />
            <CTASection />
          </main>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default Index;
